import React, { type PropsWithChildren } from 'react';
import { StyleSheet } from 'react-native';

import { theme, TransparentModal, useResponsive } from '@sg/garnish';

// ─────────────────────────────────────────────────────────────────────────────

export const GroupOrderModal = (props: GroupOrderModalProps) => {
  const { children, onClose } = props;

  const { match } = useResponsive();

  return (
    <TransparentModal
      size="medium"
      fitHeight
      onClose={onClose}
      style={match([styles.modalContainerXS, undefined])}
    >
      {children}
    </TransparentModal>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  modalContainerXS: {
    flex: undefined,
    marginTop: 'auto',
    borderTopStartRadius: theme.radius.large,
    borderTopEndRadius: theme.radius.large,
    ...theme.elevations[24],
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type GroupOrderModalProps = PropsWithChildren<{
  onClose: () => void;
}>;
